<template>
    <form class="wrapper tab-email" role="form" method="post" @submit.prevent="submit" novalidate>
        <figure class="email-image">
            <img src="imgs/web/img_onboarding.webp" srcset="imgs/web/img_onboarding.webp 1x, imgs/web/img_onboarding@2x.webp 2x" alt="">
        </figure>

        <div class="email-form">
            <span class="new-headline-md">Wohin sollen wir die Informationen senden?</span>

            <p class="new-text-lg text-color-default">Wir senden Ihnen die nächsten Schritte per E-Mail. Ihre Daten werden dabei nach höchsten Datenschutzstandards geschützt.</p>

            <form-input-type-email
                name="email"
                label="E-Mail-Adresse"
                :errors="errors.email"
                full-border
                required
            ></form-input-type-email>

            <form-input-type-checkbox
                name="agreements"
                label='Ich akzeptiere die <a href="/datenschutzerklarung" target="_blank">Datenschutzerklärung</a>.'
                :errors="errors.agreements"
                required
            ></form-input-type-checkbox>

            <v-button type="submit" label="Weiter" :disabled="sending"></v-button>
        </div>
    </form>
</template>

<script>
    export default {
        props: {
            sending: {
                type: Boolean,
                required: false,
                default: false
            },
            errors: {
                type: Object,
                required: false,
                default: () => ({})
            }
        },

        methods: {
            submit() {
                const email = ($('#email').val() || '').trim()
                const agreements = $('#agreements').is(':checked')

                if (!email) {
                    this.$set(this.errors, 'email', ['E-Mail-Adresse muss eingetragen werden.'])
                }

                if (!agreements) {
                    this.$set(this.errors, 'agreements', ['Bitte akzeptieren Sie die Datenschutzerklärung.'])
                }

                if (!email || !agreements) {
                    Vuemit.fire('Button--sending-failed', true)

                    return
                }

                this.$emit('answer', { email, agreements })
            }
        }
    }
</script>
